/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { Row, Col, Button,FormGroup,Table,Modal } from 'reactstrap';
import '../../../../../../Assets/EnsembleStyles/EnsCreateTenant.css';
import {FaQuestionCircle} from 'react-icons/fa';
import { Redirect } from 'react-router-dom';
import { SaveMeterDetailsforClient } from '../../../../../../action/manageTenantAction';
import { GetDatalogValueForMeterObjects } from '../../../../../../action/tenantMeterAction';
//import { GetDatalogValue } from '../../../../../../action/tenantMeterAction';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';
import AddMetersSearch from '../CreateTenant/Modal_Forms_Create/AddMetersSearch';
import classnames from 'classnames';
import { connect } from "react-redux";
import Currencies from '../../../../../../Resources/Currencies';
import DMResources from '../../../../../../Resources/DMResources.en-US';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import Conversions from '../../../../../../Resources/Conversions';
import { getAllResources } from '../../../../../../action/cultureAction';

  let MeterList = [];
  let IsEdit = false;


class Tenant_Meters extends Component {

    componentWillMount() {
        MeterList = [];
        if(this.props.ClientSideMeterState != undefined && this.props.ClientSideMeterState.length)
        {
            MeterList = this.props.ClientSideMeterState;
        }
    }
    componentDidMount(){
        if(this.props.getLabels["ManageTenants.Create.Text"] === undefined){
            this.props.getAllResources();
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            redirect:  false,
            rowsCount: 3,
            redirectBack:false,
            MeterID:null,
            error_msg:false,
            DatalogModalSearch: false,
            dummy_msg: ''  
        }
       this.toggle = this.toggle.bind(this);
       this.goNext = this.goNext.bind(this);
       this.goBack = this.goBack.bind(this);
    }
   
    goBack (){
        this.setState({redirectBack: true});
        this.props.SaveMeterDetailsforClient(MeterList);
    }
    
    goNext (e) {
        this.setState({redirect: true});
        this.props.SaveMeterDetailsforClient(MeterList);
    }
    toggle() {
        this.setState({
            DatalogModalSearch: !this.state.DatalogModalSearch
        });
    }

      CloseModal = (someArg1) => {

        if(someArg1!='Cancel'){ 
            
            const  actionResponse  =  this.props.GetDatalogValueForMeterObjects(someArg1.objectId,someArg1.unit);
            actionResponse.then((result) => {
                if(this.props.DatalogValue !== undefined && this.props.DatalogValue !== null){
                    someArg1.datalogValue = this.props.DatalogValue;
                    this.setState({dummy_msg:''});
                }             
            })
            let IsNewMeter =  MeterList.filter(el => el.id === someArg1.id);
            if(IsNewMeter.length)
                MeterList[someArg1.id] = someArg1;
            else
                MeterList.push(someArg1);
        }
        IsEdit = false;
        this.toggle();
    }


    ViewMeterDetailslink(MeterId) {
        this.setState({
            MeterID: MeterId,
            DatalogModalSearch: !this.state.DatalogModalSearch    
        });
        IsEdit = true;
      }

      DeleteMeter(Rows) {
        this.setState({ error_msg: false });
        let IsAnySelected = false;
        let newList = [];
        for (let i = 0; i < Rows.length; i++) {
            //var id = Rows[i].key;
            var id = Rows[i].props.children[0].props.children.ref;
            if (!this.refs[id].checked) {
               newList.push(MeterList[i]);
            }else{
                IsAnySelected = true;
            }
        }
          if (IsAnySelected) {
              MeterList = newList;
              this.setState({
                  redirect: false
              });
          } else {
            this.setState({ error_msg: true });
          }
    }

    render(ClientSideComapnyState,ClientSideMeterState,Response_of_Datalog_Value, getLabels, UserPreference_response) {
        let Meters = null,Error_Message;
        if(this.state.redirect){
            if(this.props.ClientSideComapnyState != undefined){
                if(this.props.ClientSideComapnyState.HasFixedRate)
                    return <Redirect to={"/managetenant/TenantFixedCharges"} />
                else
                    return <Redirect to={"/managetenant/ConfirmTenantSettings"} />
            }
        }
        if(this.state.redirectBack){
            if(this.props.ClientSideComapnyState != undefined){
                if(this.props.ClientSideComapnyState.HasAfterHrs)
                    return <Redirect to={"/managetenant/TenantEmployeeUsers"} />
                else 
                    return <Redirect to={"/managetenant/CreateTenant"} /> 
            }
        }
        
        let label = this.props.getLabels;
        let PreferedDateFormat = this.props.UserPreference_response;
        // Error Message
      (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />{label['CheckEmptyTenant.Text']}</p> : Error_Message = " ";
        
        if(MeterList != undefined || MeterList != null){
             
            let CurrencySymb = "";
                if(this.props.ClientSideComapnyState !== undefined && this.props.ClientSideComapnyState !== null){
                    CurrencySymb=  Currencies.CurrencySymbol(this.props.ClientSideComapnyState.CurrencyId);
                }
                if(MeterList.length > 0){

                    Meters = MeterList.map(el => {
                        var l_value = "---";
                        
                        if(el.datalogValue != null){
                          l_value = parseFloat(el.datalogValue).toFixed(2) + " "+ (el.unit != 0 && el.unit != 99999 ? DMResources.FamilyList('Enum3046.'+ el.unit +'.Text') : el.unitText);
                        }
                      return <tr key={el.id}>
                          <td><input type="checkbox" id={el.id} ref={'ref1_' + el.id} value={el.id} className="ZoneRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("ZoneRows", "main_Check_box"); }} /></td>
                          <td onClick={() => {this.ViewMeterDetailslink(el.id)}} style={{color:'#6890C6'}}  className="link_cursor">{el.customName}</td>
                          <td>
                            {
                                (el.buildingName !== "" && el.objectName !== "") ?
                                el.buildingName + " , " + el.objectName : ""
                            }
                          </td>
                          <td>{el.multiplier}</td>
                          <td style={{"font-family":"Arial"}}>{CurrencySymb}{" "}{Conversions.formatNumber(PreferedDateFormat,el.rate)}{" Per "}{el.unit != 0 && el.unit != 99999 ? DMResources.FamilyList('Enum3046.'+ el.unit +'.Text') : el.unitText}</td>
                          <td>{l_value}</td>
                      </tr>
                    });
                }


                else{
                    Meters =  <tr> <td colSpan="6">{label['NoRecords.Text']}</td> </tr>
                }
        }
        else{
            Meters = <p>{label['LoadingData.Text']}</p>
        }

        return (
            <div className="EnsembleCreateTenant">
                   <Row>
                 <Col sm={{size: 1, offset: 11 }} className="text-right" >
                 <FaQuestionCircle className="Ensemble_Icon Ensemble_question_Icon" />
                 </Col>
                 </Row>
                 <h4 className="form_title">{label['TenantConsumption.UsageMeters.Text']}</h4>
                 <div className="Customised_form_div">
                    {Error_Message}
                    <Button id="createtenant_meter_delete" type="button" className="btn btn-black" onClick={() => { this.DeleteMeter(Meters); }}>{label['FixedRateSetup.DeleteFixedRate.Text'] !== undefined  ? label['FixedRateSetup.DeleteFixedRate.Text'] : "Delete"}   </Button>
                    <Button id="createtenant_meter_add" type="button" className="btn btn-success  TenantActionBtns"  onClick={this.toggle}> {label['TenantConsumption.AddMeter.Text'] !== undefined ? label['TenantConsumption.AddMeter.Text'] : "Add Meter"} </Button>
                    
                   <div className="table_container" style={{paddingRight:'15px'}}>
                        <Table striped responsive className="Custom_table table_border">
                            <tbody className="cell_container tenant_cell">
                                <tr>
                                    <th><input type="checkbox" className="main_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("ZoneRows", "main_Check_box"); }} /></th>
                                    <th className="link_cursor">{label['FixedRateSetup.Name.Text'] !== undefined ? label['FixedRateSetup.Name.Text'] : "Name"}  </th>
                                    <th className="link_cursor">{label['TenantConsumption.DataSource.Text'] !== undefined ? label['TenantConsumption.DataSource.Text'] : "Data Source"}</th>
                                    <th className="link_cursor">{label['TenantConsumption.Multiplier.Text'] !== undefined ? label['TenantConsumption.Multiplier.Text'] : "Multiplier"}</th>
                                    <th className="link_cursor">{label['TenantConsumption.Rate.Text'] !== undefined ? label['TenantConsumption.Rate.Text'] : "Rate"}</th>
                                    <th className="link_cursor">{label['TenantConsumption.CurrentReading.Text'] !== undefined ? label['TenantConsumption.CurrentReading.Text'] : "Current Reading"} </th>
                                </tr>

                            {Meters}
                            </tbody>
                        </Table>
                   </div>

               
                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button id="createtenant_meter_back" className="btn-gray btn-md" onClick={this.goBack}> {label['Wizards.BackButton.Text']} </Button>
                            <Button id="createtenant_meter_next" className="btn-success btn-md" onClick={this.goNext}>{label['Wizards.NextButton.Text']}</Button>
                        </Col>
                    </FormGroup>
                </div> 

                <Modal isOpen={this.state.DatalogModalSearch} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} style={{ 'width': '990px', 'height': '400px' }}>
                    <AddMetersSearch CloseModal={this.CloseModal} MeterListIndex={MeterList} MeterListDetail={MeterList[this.state.MeterID]} IsEdit={IsEdit} />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ClientSideComapnyState: state.manageTenant.ClientSideComapnyData,
        ClientSideMeterState: state.manageTenant.ClientSideMeterData,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
        DatalogValue: state.ViewtenantsRootReducer.DatalogValueForMeterObject     
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SaveMeterDetailsforClient: (data) => dispatch(SaveMeterDetailsforClient(data)),
        getAllResources: () => dispatch(getAllResources()),
        GetDatalogValueForMeterObjects: (ObjectId,Unit) => dispatch(GetDatalogValueForMeterObjects(ObjectId,Unit))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tenant_Meters);

